import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ChartContainer from "../../../../../../app/common-components/ChartContainer";
import Spinners from "../../../../../../app/common-components/Spinner";
import CatagorizedContainer from "./catagoryContanier";
import "./styles.css";
import Uncategorised from "./uncatagorizedContanier";
import { CATEGORY_TYPES } from "./Utilities/Identifiers";

const JiraRoles = (props) => {
  const activeTab = props.activeTab;
  const { IssueTypeCatagorizedData, IssueTypeConfigJiraListLoading } =
    useSelector((state) => state.toolsApi);

  const IssueTypeData = Array.isArray(IssueTypeCatagorizedData)
    ? IssueTypeCatagorizedData
    : [];

  const categorizedData = IssueTypeData.filter(
    (item) => item.categoryName !== CATEGORY_TYPES.UNCATEGORIZED
  ).sort((a, b) => a.priorityOrder - b.priorityOrder);

  const uncategorizedData = IssueTypeData.find(
    (item) => item?.categoryName === CATEGORY_TYPES.UNCATEGORIZED
  );

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
      setScreenHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Transform the API data
  //  Only create if data exists

  const issuTypeUnCategorized = uncategorizedData?.issueTypes?.length
    ? [
        {
          key: "uncategorized",
          data: uncategorizedData?.issueTypes,
          itemCount: uncategorizedData?.issueTypes?.length,
          chart: (props) => (
            <Uncategorised
              list={uncategorizedData?.issueTypes}
              count={uncategorizedData?.issueTypes?.length}
              {...props}
            />
          ),
          navContainerClass: "flowdisnav",
          chartContainerClass: "flowdistribution svg-container",
          customClass:
            "col-lg-12 col-md-12 order-md-6 order-lg-5 filtercol filetotal jiraUncatagorized",
        },
      ]
    : [];

  const issuTypecategorized = categorizedData.map((category) => ({
    key: category.configId ?? category.categoryName,
    chart: (props) => (
      <CatagorizedContainer
        title={category?.categoryName}
        order={category?.priorityOrder}
        data={Array.isArray(category?.issueTypes) ? category?.issueTypes : []}
        itemCount={
          Array.isArray(category?.issueTypes) ? category?.issueTypes?.length : 0
        }
        activeTab={activeTab}
        {...props}
      />
    ),
    navContainerClass: "flowdisnav",
    chartContainerClass: "flowdistribution svg-container",
    customClass:
      "col-lg-12 col-md-12 order-md-6 order-lg-5 filtercol filetotal jiraCategorized",
  }));

  return (
    <>
      {IssueTypeConfigJiraListLoading ? (
        <Spinners />
      ) : (
        <>
          {issuTypeUnCategorized.map((type) => {
            return (
              <ChartContainer
                key={type.key}
                {...type}
                // list={uncatData}
                // count={7}
              >
                {type.component}
              </ChartContainer>
            );
          })}
          {issuTypecategorized.map((type) => {
            return (
              <ChartContainer key={type.key} {...type}>
                {type.component}
              </ChartContainer>
            );
          })}
        </>
      )}
    </>
  );
};
JiraRoles.propTypes = {
  activeTab: PropTypes.string.isRequired,
};

export default JiraRoles;
